export default __webpack_public_path__ + "static/fox_goes_free-149775a07e7a1c4a09e35e3b2e1bff3e.jpg";